import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import notify from "devextreme/ui/notify";
import * as S from "./RechazoMotivo.styles";

interface Props {
  visible: boolean;
  deciding?: boolean;
  onClose: () => void;
  onConfirm: (motivo: string) => void;
}

const RechazoMotivoPopup: React.FC<Props> = ({
  visible,
  deciding = false,
  onClose,
  onConfirm,
}) => {
  const [motivo, setMotivo] = useState("");

  useEffect(() => {
    if (!visible) setMotivo("");
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !deciding) onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible, deciding, onClose]);

  if (!visible) return null;

  const handleConfirm = () => {
    const text = motivo.trim();
    if (!text) {
      notify("Indica el motivo del rechazo.", "warning", 2200);
      return;
    }
    onConfirm(text);
  };

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Motivo de rechazo"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 20000,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={() => {
        if (!deciding) onClose();
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 440,
          background: "#fff",
          borderRadius: 14,
          border: "1px solid #DFE1E6",
          boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <S.Card>
          <S.CloseButtonIcon
            type="button"
            title="Cerrar"
            aria-label="Cerrar"
            disabled={deciding}
            onClick={onClose}
          >
            ×
          </S.CloseButtonIcon>

          <S.Title>Motivo de rechazo</S.Title>

          <S.TextArea
            value={motivo}
            placeholder="Describe el motivo del rechazo"
            disabled={deciding}
            autoFocus
            onChange={(e) => setMotivo(e.target.value)}
          />

          <S.WarningBanner>
            <S.WarningIcon>!</S.WarningIcon>
            <span>
              Al confirmar, el registro pasará a estado Rechazado y esta acción
              no se podrá deshacer.
            </span>
          </S.WarningBanner>

          <S.ActionsRow>
            <S.ConfirmRejectButton
              type="button"
              disabled={deciding}
              onClick={handleConfirm}
            >
              {deciding ? "Procesando..." : "Confirmar rechazo"}
            </S.ConfirmRejectButton>
            <S.CancelButton
              type="button"
              disabled={deciding}
              onClick={onClose}
            >
              Cancelar
            </S.CancelButton>
          </S.ActionsRow>
        </S.Card>
      </div>
    </div>,
    document.body,
  );
};

export default RechazoMotivoPopup;
